import { useEffect, useState } from "react";
import { GuestAccessModal, GuestAccessProps } from "./guest-access-modal/GuestAccessModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

interface GuestAccessKmeItemProps extends GuestAccessProps {
    // props injected by the MeetingRoom Component
    onClose: () => void;
}

/**
 * guest access closeable modal for KME custom menu item
 */
export const GuestAccessKmeItem = (props: GuestAccessKmeItemProps) => {
    const { onClose, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(true);
    const sendButtonAnalytics = useButtonAnalytics();

    useEffect(() => {
        sendButtonAnalytics(
            "Manage Guest access",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Media kme"
        );
    }, []);

    const closeModal = () => {
        setIsOpen(false);
        onClose();
    };

    if (isOpen) {
        return (
            <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Manage guest access modal"}>
                <GuestAccessModal {...modalProps} isOpen={isOpen} onClose={closeModal} />
            </ButtonAnalyticsProvider>
        );
    }
    else {
        return null;
    }
};
